import React, { createContext, useState, useEffect, useContext } from 'react';

// ═══ تعريف الألوان المتاحة ═══
export const THEMES = {
  blue: {
    id: 'blue',
    name: 'أزرق كلاسيكي',
    emoji: '🔵',
    primary: 'blue',
    navFrom: 'from-blue-600',
    navTo: 'to-blue-700',
    heroFrom: 'from-blue-600',
    heroVia: 'via-blue-700',
    heroTo: 'to-blue-900',
    btnHover: 'hover:bg-blue-500',
    textMuted: 'text-blue-100',
    textMuted2: 'text-blue-200',
    textMuted3: 'text-blue-300',
    footerBg: 'bg-blue-950',
    statsBg: 'bg-blue-900/50',
    sectionBadge: 'bg-white/10',
    accent: 'blue-500',
  },
  indigo: {
    id: 'indigo',
    name: 'نيلي أنيق',
    emoji: '🟣',
    primary: 'indigo',
    navFrom: 'from-indigo-600',
    navTo: 'to-indigo-700',
    heroFrom: 'from-indigo-600',
    heroVia: 'via-indigo-700',
    heroTo: 'to-indigo-900',
    btnHover: 'hover:bg-indigo-500',
    textMuted: 'text-indigo-100',
    textMuted2: 'text-indigo-200',
    textMuted3: 'text-indigo-300',
    footerBg: 'bg-indigo-950',
    statsBg: 'bg-indigo-900/50',
    sectionBadge: 'bg-white/10',
    accent: 'indigo-500',
  },
  emerald: {
    id: 'emerald',
    name: 'أخضر زمردي',
    emoji: '🟢',
    primary: 'emerald',
    navFrom: 'from-emerald-600',
    navTo: 'to-emerald-700',
    heroFrom: 'from-emerald-600',
    heroVia: 'via-emerald-700',
    heroTo: 'to-emerald-900',
    btnHover: 'hover:bg-emerald-500',
    textMuted: 'text-emerald-100',
    textMuted2: 'text-emerald-200',
    textMuted3: 'text-emerald-300',
    footerBg: 'bg-emerald-950',
    statsBg: 'bg-emerald-900/50',
    sectionBadge: 'bg-white/10',
    accent: 'emerald-500',
  },
  rose: {
    id: 'rose',
    name: 'وردي أنيق',
    emoji: '🔴',
    primary: 'rose',
    navFrom: 'from-rose-600',
    navTo: 'to-rose-700',
    heroFrom: 'from-rose-600',
    heroVia: 'via-rose-700',
    heroTo: 'to-rose-900',
    btnHover: 'hover:bg-rose-500',
    textMuted: 'text-rose-100',
    textMuted2: 'text-rose-200',
    textMuted3: 'text-rose-300',
    footerBg: 'bg-rose-950',
    statsBg: 'bg-rose-900/50',
    sectionBadge: 'bg-white/10',
    accent: 'rose-500',
  },
  amber: {
    id: 'amber',
    name: 'ذهبي دافئ',
    emoji: '🟡',
    primary: 'amber',
    navFrom: 'from-amber-600',
    navTo: 'to-amber-700',
    heroFrom: 'from-amber-600',
    heroVia: 'via-amber-700',
    heroTo: 'to-amber-900',
    btnHover: 'hover:bg-amber-500',
    textMuted: 'text-amber-100',
    textMuted2: 'text-amber-200',
    textMuted3: 'text-amber-300',
    footerBg: 'bg-amber-950',
    statsBg: 'bg-amber-900/50',
    sectionBadge: 'bg-white/10',
    accent: 'amber-500',
  },
  slate: {
    id: 'slate',
    name: 'رمادي داكن',
    emoji: '⚫',
    primary: 'slate',
    navFrom: 'from-slate-700',
    navTo: 'to-slate-800',
    heroFrom: 'from-slate-700',
    heroVia: 'via-slate-800',
    heroTo: 'to-slate-900',
    btnHover: 'hover:bg-slate-600',
    textMuted: 'text-slate-200',
    textMuted2: 'text-slate-300',
    textMuted3: 'text-slate-400',
    footerBg: 'bg-slate-950',
    statsBg: 'bg-slate-900/50',
    sectionBadge: 'bg-white/10',
    accent: 'slate-500',
  },
};

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [themeId, setThemeId] = useState(() => {
    return localStorage.getItem('solou-theme') || 'blue';
  });

  const theme = THEMES[themeId] || THEMES.blue;

  useEffect(() => {
    localStorage.setItem('solou-theme', themeId);
  }, [themeId]);

  const changeTheme = (id) => {
    if (THEMES[id]) {
      setThemeId(id);
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, themeId, changeTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
